export default "__VITE_ASSET__CYs2EN5U__"